<template lang="pug">
transition(name="form-slide")
  .cp-form-modal(v-if="modal")
    .modal(v-if="modal")
      .close-btn(@click="closeModal")
      p.form-title 免费体验
      p 您将会接听到由去电Ai拨打的测试电话
      p 为了不给您工作造成影响，试用时间统一安排在每日16:00
      p.tip *为了保证产品的试用体验，请如实填写下述信息
      .form
        .form-item
          .label 姓名
          input(v-model.trim="form.proposerName", placeholder="请输入您的姓名")
        .form-item
          .label 手机号
          input(v-model.trim="form.proposerMobile", placeholder="请输入您的手机号", maxlength="11")
        .form-item
          .label 验证码
          input(v-model.trim="form.captcha", placeholder="请输入验证码")
          .send-btn(v-if="canGetCode", @click="handleSendVerifica") 发送验证码
          .send-btn(v-else) 重新发送({{getCodeTime}})
        .form-item
          .label 公司名称
          input(v-model.trim="form.proposerCompanyName", placeholder="请输入您所在的公司名称")
        .form-item
          .label 所属行业
          ul.check-box-list
            li.check-box-item(v-for="(v, index) in checkBoxList", @click="handleChangeTradeType(index)")
              .check-box(:class="form.tradeType === v.value ? 'checked' : ''")
              .tag {{v.label}}
      a.btn(@click="submit") 提交
    tip(ref="tip")
</template>
<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      modal: false,
      canGetCode: true,
      getCodeTime: 60,
      initGetCodeTime: 60,
      form: {
        captcha: '',
        proposerName: '',
        proposerMobile: '',
        proposerCompanyName: '',
        // 申请类型：1.直客；2.代理商；
        proposerType: '',
        tradeType: '1',
      },
      checkBoxList: [
        { label: '金融', value: '1' },
        { label: '企业服务', value: '2' },
        { label: '泛房产', value: '3' },
        { label: '教育培训', value: '4' },
        { label: '汽车', value: '5' },
        { label: 'BPO Callcenter', value: '6' },
        { label: '媒体', value: '7' },
        { label: '投资机构', value: '8' },
        { label: '其他', value: '9' },
      ],
    }
  },
  computed: {},
  methods: {
    handleChangeTradeType (index) {
      this.currentIndex = index
      this.form.tradeType = this.checkBoxList[index].value
    },
    boot () {
      this.form.captcha = ''
      this.form.proposerName = ''
      this.form.proposerMobile = ''
      this.form.proposerCompanyName = ''
      this.form.proposerType = ''
      this.form.tradeType = '1'
      this.modal = true
    },
    closeModal () {
      this.modal = false
    },
    handleSendVerifica () {
      const mobile = this.form.proposerMobile

      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(mobile))) {
        this.$refs['tip'].showTip('请输入正确手机号')
        return
      }

      this.canGetCode = false
      this.$http.getCode({ mobile }).then(res => {
        if (res.data.code === 1001) {
          this.$refs['tip'].showTip('验证码发送成功')
        } else {
          this.$refs['tip'].showTip('验证码发送失败')
        }
      })

      let interval = setInterval(() => {
        if (this.getCodeTime <= 0) {
          this.canGetCode = true
          this.getCodeTime = this.initGetCodeTime
          clearInterval(interval)
        } else {
          this.getCodeTime--
        }
      }, 1000)
    },
    submit () {
      if (!this.form.proposerName) {
        this.$refs['tip'].showTip('请输入联系人姓名')
        return
      }

      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.form.proposerMobile))) {
        this.$refs['tip'].showTip('请输入正确手机号')
        return
      }

      if (!this.form.captcha) {
        this.$refs['tip'].showTip('请输入验证码')
        return
      }

      if (!this.form.proposerCompanyName) {
        this.$refs['tip'].showTip('请输入公司名称')
        return
      }

      if (!this.form.tradeType) {
        this.$refs['tip'].showTip('请选择所属行业')
        return
      }

      this.form.proposerType = '1'

      this.$http.postProposer(this.form).then(res => {
        if (res.data.code === 1001) {
          this.$refs['tip'].showTip('提交成功')
          this.closeModal()
        } else {
          this.$refs['tip'].showTip(res.data.message)
        }
      })
    },
  }
}
</script>
<style lang="stylus">
.cp-form-modal
  position fixed
  top 0
  left 0
  right 0
  bottom 0
  margin auto
  z-index 1000
  .modal
    position relative
    display flex
    flex-direction column
    flex-wrap wrap
    justify-content center
    align-items center
    width 770px
    height 650px
    margin 80px auto 0px
    background rgba(33,58,105,0.95)
    border-radius 3px
    .close-btn
      width 15px
      height 15px
      position absolute
      top 25px
      right 25px
      cursor pointer
      &::before
        content ''
        display block
        width 100%
        height 1px
        background #9EEAFA
        position absolute
        top 5px
        transform rotate(45deg)
        // transition all .3s
      &::after
        content ''
        display block
        width 100%
        height 1px
        background #9EEAFA
        position absolute
        top 5px
        transform rotate(-45deg)
        // transition all .3s
      &:hover
        &::before,&::after
          background #fff
    p
      text-align center
      color rgba(255,255,255,0.6)
    .form-title
      margin-bottom 10px
      font-size 24px
      letter-spacing 1px
      text-align center
      color rgba(255,255,255,1)
    .tip
      margin-top 50px
      margin-bottom 20px
      color rgba(158,234,250,1)
    .form
      .form-item
        margin-bottom 13px
        .label
          display inline-block
          vertical-align middle
          width 60px
          margin-right 30px
          text-align right
        input
          width 340px
          height 40px
          background rgba(23,46,93,1)
          border none
          padding-left 20px
          &::placeholder
            color rgba(255,255,255,0.2)
            font-weight 400
        .check-box-list
          float right
          width 350px
          display flex
          flex-wrap wrap
          justify-content space-between
          .check-box-item
            margin-bottom 25px
            display flex
            justify-content center
            align-items center
            cursor pointer
            .check-box
              width 14px
              height 14px
              margin-right 6px
              border-radius 50%
              background rgba(23,46,93,1)
            .checked
              display flex
              justify-content center
              align-items center
              &::before
                content ''
                display block
                width 8px
                height 8px
                background #16aaba
                border-radius 50%
        &:nth-child(3)
          input
            width 198px
          .send-btn
            display inline-block
            width 132px
            height 40px
            margin-left 10px
            border-radius 2px
            border 1px solid rgba(158,234,250,1)
            font-size 14px
            line-height 40px
            text-align center
            color rgba(158,234,250,1)
            cursor pointer
            transition all .3s
            &:hover
              background rgba(158,234,250,.4)
    .btn
      width 192px
      height 48px
      margin-top 25px
      background rgba(22,170,186,1)
      border-radius 5px
      border 1px solid rgba(98,242,255,1)
      line-height 48px
      text-align center
      color #fff
      cursor pointer
      transition all .3s
      &:hover
        background rgba(22,170,186,.4)
.form-slide-enter
  opacity 0
  transform translate3d(0px, 150px, 0px)
.form-slide-leave-to
  opacity 0
  transform translate3d(0px, -150px, 0px)
.form-slide-enter-active, .form-slide-leave-active
  transition all .5s
</style>
